import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Menubar } from 'primeng/menubar';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SidebarService } from '../../services/sidebar.service';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import * as TableIcons from 'angular-tabler-icons/icons';
import { TablerIconComponent,provideTablerIcons } from 'angular-tabler-icons';
import { KeycloakService } from '../../../../../usermgmt/src/lib/services/keycloak.service';
import { UtilsService } from '../../../../../usermgmt/src/lib/services/utils.service';
import { StationSurveyStepperService } from '../../components/survey-stepper/services/station-survey-stepper.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { UndoRedoService } from '../../services/layout/undo-redo/undo-redo.service';



@Component({
  selector: 'app-header',
  standalone: true,
  imports: [Menubar, BadgeModule, AvatarModule, InputTextModule, CommonModule, ButtonModule, OverlayPanelModule,BreadcrumbModule,TablerIconComponent,ConfirmDialogModule],
  providers:[provideTablerIcons({
    ...TableIcons}), ConfirmationService],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
    

  items: MenuItem[] | undefined;
  isCollapsed = true;
  username!: string;
  queryParams: any;

  constructor(private router: Router,private sidebarService:SidebarService,private utilService:UtilsService,private keyCloakService:KeycloakService, private stepperSrv: StationSurveyStepperService, private confirmationService: ConfirmationService, private undoRedoService: UndoRedoService, private route: ActivatedRoute) {}

  ngOnInit() {
      this.items = [
          {
              label: 'Home',
              icon: 'pi pi-home',
          },
      ];

      this.router.events.subscribe(() => {
          this.getUserInfo();
      })

      this.route.queryParams.subscribe((params: any) => {
        this.queryParams = params;
      });
  }

toggleSidebar(){
   this.sidebarService.toggleSidebar();
}

  isProfileMenuOpen = false;

  toggleProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  stopPropagation(event: Event) {
    event.stopPropagation();

  }

  navigateToLoginPage() {
    this.router.navigate(['/login']);
  }

  async logout() {
    // Wait for the unlocks to actually complete before Keycloak revokes the token
    // and reloads the page.
    await this.stepperSrv.releaseHeldLocks();
    this.keyCloakService.logout();
  }


  private isOnDraftRoute(): boolean {
    return this.router.url.startsWith('/addStation') && this.router.url.includes('isDraftLoad=true');
  }

  navigateToLanding() {
    if (this.isOnDraftRoute() && this.stepperSrv.hasUnsavedChanges()) {
      this.confirmationService.confirm({
        header: 'Unsaved Changes',
        message: 'You have unsaved changes. Going back will discard any unsaved progress.',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Proceed',
        rejectLabel: 'Cancel',
        rejectButtonStyleClass: 'p-button-text',
        accept: () => {
          this.stepperSrv.removeStationDataFromLocalStorage();
          this.stepperSrv.removeSurveyDataFromLocalStorage();
          this.router.navigate(['/landing']);
        }
      });
    } else {
      this.undoRedoService.clearAll(this.queryParams['station_uuid']);
      this.stepperSrv.removeStationDataFromLocalStorage();
      this.stepperSrv.removeSurveyDataFromLocalStorage();
      this.router.navigate(['/landing']);
    }
  }

  getUserInfo(){
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      this.username = JSON.parse(userInfo)?.username;
    }
  }
}
